import {Link, useNavigate, useParams} from "react-router-dom";
import {Helmet} from "react-helmet-async";
import {
    Button, ButtonGroup,
    Card,
    CardContent, CircularProgress,
    Container,
    Stack,
    Table, TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Select from "@mui/material/Select";
import {Option} from "@mui/joy";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import EditIcon from "@mui/icons-material/Edit";
import {useGetFacultyCoursesQuery} from "../store/faculty/facultyApi";
import {useEffect, useState} from "react";
import {useDeleteAttestationMutation, useGetFacultyAttestationsQuery} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import copyObject from "../utils/copyObject";
import {PanoramaFishEye} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function FacultyAttestationsPage() {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(0);
    const {data: facultyCourses} = useGetFacultyCoursesQuery();
    const getFacultyAttestations = useGetFacultyAttestationsQuery({courseId: selectedCourse});
    const [copyOfFacultyCourses, setCopyOfFacultyCourses] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const isAdmin = localStorage.getItem('roles').split(',').find((item) => item === 'AttNewAdmin') !== undefined;
    const [deleteRequest] = useDeleteAttestationMutation();
    
    useEffect(() => {
        setCopyOfFacultyCourses(copyObject(facultyCourses));

        if (selectedCourse !== 0 && !selectedCourse) {
            return;
        }

        // setIsLoading(true);
        // getFacultyAttestations.refetch().unwrap().then((fulfilled) => {
        //    setIsLoading(false);
        //    setData(copyObject(fulfilled));
        // });
        
        refetch();
    }, [selectedCourse, facultyCourses]);
    
    function refetch() {
        setIsLoading(true);
        getFacultyAttestations.refetch().unwrap().then((fulfilled) => {
            setIsLoading(false);
            setData(copyObject(fulfilled));
        });
    }

    const onCourseChanged = async (value) => {
        setSelectedCourse(value);
    }

    function toDateString(date){
        return new Date(date).toLocaleDateString("ru-RU");
    }
    
    async function handleDelete(attestationId) {
        const confirmed = window.confirm("Вы действительно хотите удалить аттестацию?");
        
        if (!confirmed) {
            return;
        }
        
        setIsDeleting(true);
        
        await deleteRequest({ data: { attestationId } })
            .unwrap()
            .then((fulfilled) => {
                if (fulfilled?.success) {
                    alert('Аттестация удалена');
                    refetch();
                } else {
                    fulfilled.errors.map((item) => {
                        alert(item);
                        return 1;
                    });
                }
                
                setIsDeleting(false);
            }).catch((reason) => {
                alert("Ошибка");
                setIsDeleting(false);
            });
    }

    return <GeneralLayout>
        <PageTitle title={`Список аттестаций`} />

        <Container>
            <Stack
                padding="120px 0px 0px 100px"
                direction="column"
                spacing={6}
            >
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" gutterBottom>
                        Список аттестаций
                    </Typography>
                </Stack>
                
                <Card>
                    <CardContent>
                        <Stack direction="row" spacing={3}>
                            <Typography alignSelf="center">Курс</Typography>

                            <Select
                                onChange={(event) => { onCourseChanged(event.target.value); }}
                                fullWidth
                                sx={{
                                    maxWidth: '100%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                {copyOfFacultyCourses?.data?.sort((l,r) => l.value > r.value ? 1 : -1).map((item) => {
                                    return <MenuItem value={item.key}>{item.value}</MenuItem>
                                })}
                            </Select>
                            
                            <Button startIcon={<AddIcon />}
                                    disabled={selectedCourse === null}
                                    href={`/createattestation/${selectedCourse}`}
                                    variant="contained">Создать аттестацию</Button>
                        </Stack>
                    </CardContent>
                </Card>

                <Card>
                    {data !== null && data !== undefined
                    ? <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>№ аттестации</TableCell>
                                    <TableCell>Группы</TableCell>
                                    <TableCell>Период</TableCell>
                                    <TableCell>Операции</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.attestations?.sort((l,r) => l.courseName > r.courseName 
                                    ? 1 : 
                                    (l.courseName === r.courseName 
                                        ? (l.attestationNumber > r.attestationNumber ? 1 : -1)
                                        : l.courseName < r.courseName ? -1 : 1)).map((item) => {
                                    return <TableRow>
                                        <TableCell>
                                            <Typography fontSize={'medium'} fontWeight={'bold'}>№{item.attestationNumber}</Typography>
                                            {!selectedCourse
                                            ? <> {item.courseName} </>
                                            : ''}
                                        </TableCell>
                                        <TableCell>{item.groups?.map(item => item.groupName).sort().join(', ')}</TableCell>
                                        <TableCell>{toDateString(item.startDate)} - {toDateString(item.endDate)}</TableCell>
                                        <TableCell>
                                            <ButtonGroup orientation="vertical">
                                                <Button startIcon={<InsertDriveFileOutlinedIcon />}
                                                        size={'small'}
                                                        href={`/attestationdetails/${item.attestationId}`}>Ведомости</Button>
                                                <Button startIcon={<EditIcon />}
                                                        size={'small'}
                                                        href={`/editattestation/${item.attestationId}`}>Редактировать</Button>
                                                {isAdmin
                                                    ? <Button startIcon={<DeleteIcon />}
                                                              size={'small'}
                                                              onClick={() => handleDelete(item.attestationId)}
                                                              color={'error'}
                                                              >Удалить</Button>
                                                    : <></>
                                                }
                                            </ButtonGroup>
                                        </TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table>
                    : <CardContent>
                            <Typography align="center">
                                {isLoading 
                                ? <CircularProgress />
                                : <>Выберите курс из списка выше</>}
                            </Typography>
                        </CardContent>}
                </Card>
                <br />
            </Stack>
        </Container>
    </GeneralLayout>
}